import { FC, ReactNode } from "react"
import { IconButton, IconButtonProps } from "@mui/material"

import { CloseIcon } from "../icons"

interface IBackIconButtonProps extends IconButtonProps {
  icon?: ReactNode
}

export const CloseIconButton: FC<IBackIconButtonProps> = ({
  icon = <CloseIcon fontSize="inherit" />,
  ...props
}) => {
  return (
    <IconButton aria-label="close" color="inherit" size="small" {...props}>
      {icon}
    </IconButton>
  )
}
